import { camelCaseKeys, useFlags } from 'launchdarkly-react-client-sdk';

export const defaultFlags = {
  'verifx-notarize': false,
  'verifx-enable-persona-codl-cr': false,
  'verifx-enable-codl-magic-links': false,
  'enable-pre-delivery-cr': false,
  'verifx-enable-cv-customer-requests': false,
  'verifx-dl-magic-session': false
};

type CamelCase<S extends string> = S extends `${infer T}-${infer U}`
  ? `${T}${Capitalize<CamelCase<U>>}`
  : S;

type FeatureFlags = {
  [K in keyof typeof defaultFlags as CamelCase<K>]: (typeof defaultFlags)[K];
};

const defaultCamelCasedFlags = camelCaseKeys(defaultFlags) as FeatureFlags;

export const useFeatureFlags = () => {
  const flags = useFlags<FeatureFlags>();
  return { ...defaultCamelCasedFlags, ...flags };
};
